import TYPES from './types';

const INITIAL_STATE = {
  routePoints: []
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TYPES.GET_ROUTE_POINTS.SUCCESS:
      return {
        ...state,
        routePoints: payload
      };
    default:
      return state;
  }
};

export default reducer;
